import classNames from 'classnames';
import React, { VFC, ReactElement } from 'react';

import { JourneyMenuPropsInterface } from 'src/common/JourneyMenu';
import { LeftStrongIcon } from 'src/monet/icons';
import { SmallPanel } from 'src/common/ui/small-panel';

export interface DashboardHomeCommonConfirmPanelProps
  extends Pick<
    JourneyMenuPropsInterface,
    'openRef' | 'closeRef' | 'placement' | 'offset' | 'renderOrigin' | 'onOpen' | 'onClose'
  > {
  content: string | ReactElement;
  confirmText: string;
  denyText?: string;
  onConfirm?: () => void;
  onDeny?: () => void;
  onBack?: () => void;
  containerClassName?: string;
}

export const DashboardHomeDeleteConfirmPanel: VFC<DashboardHomeCommonConfirmPanelProps> = ({
  content,
  onConfirm,
  onDeny,
  onBack,
  confirmText,
  denyText,
  containerClassName,
  ...popoverProps
}) => {
  return (
    <SmallPanel openAfterMount hasBackButton onBack={onBack} containerClassName={containerClassName} {...popoverProps}>
      <div className='flex flex-col space-y-md'>
        <div className='text-bedrock-p text-bedrock-black cursor-default'>{content}</div>
        <div className='flex items-center space-x-2'>
          <button type='button' className='btn-bedrock-red' onClick={onConfirm}>
            {confirmText}
          </button>
          <button type='button' className='btn-bedrock-secondary' onClick={onDeny}>
            {denyText}
          </button>
        </div>
      </div>
    </SmallPanel>
  );
};
